/*
 * Ocean Racing — sitewide UI enhancements
 * Built by North Track Digital
 *
 * 1. Best-sellers slider: injects prev/next arrows synced to scroll position.
 * 2. (moved) Card colour swatches now live in ntd-card.js.
 * 3. Slider add-to-cart: intercepts the native form POST (which navigated to
 *    the cart page) and adds via AJAX, opening the cart drawer instead — the
 *    slider is used on the homepage and as the PDP cross-sell. Falls back to
 *    the native submit if anything goes wrong.
 *
 * No requestAnimationFrame and no CSS-transition dependencies. Timers only.
 */
(function () {
  'use strict';

  if (window.__ntdEnhance) return;
  window.__ntdEnhance = true;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* ---------- 1. Slider arrows ---------- */

  function enhanceSliders() {
    document.querySelectorAll('.bs-slider').forEach(function (section) {
      if (section.dataset.ntdArrows === 'true') return;
      var track = section.querySelector('.bs-track.active') || section.querySelector('.bs-track');
      if (!track) return;
      section.dataset.ntdArrows = 'true';

      var nav = document.createElement('div');
      nav.className = 'ntd-slider-nav';
      nav.innerHTML =
        '<button type="button" class="ntd-slider-arrow" data-ntd-prev aria-label="Scroll products left">‹</button>' +
        '<button type="button" class="ntd-slider-arrow" data-ntd-next aria-label="Scroll products right">›</button>';
      section.appendChild(nav);

      var prev = nav.querySelector('[data-ntd-prev]');
      var next = nav.querySelector('[data-ntd-next]');

      function activeTrack() {
        return section.querySelector('.bs-track:not(.hidden)') || track;
      }

      function step() {
        var t = activeTrack();
        var card = t.querySelector('.bs-card');
        return card ? card.getBoundingClientRect().width + 12 : t.clientWidth * 0.8;
      }

      function sync() {
        var t = activeTrack();
        prev.disabled = t.scrollLeft <= 2;
        next.disabled = t.scrollLeft + t.clientWidth >= t.scrollWidth - 2;
      }

      prev.addEventListener('click', function () {
        activeTrack().scrollBy({ left: -step(), behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        activeTrack().scrollBy({ left: step(), behavior: 'smooth' });
      });

      var pending = false;
      function onScroll() {
        if (pending) return;
        pending = true;
        setTimeout(function () { pending = false; sync(); }, 120);
      }
      section.querySelectorAll('.bs-track').forEach(function (t) {
        t.addEventListener('scroll', onScroll, { passive: true });
      });
      section.querySelectorAll('.bs-tab').forEach(function (tab) {
        tab.addEventListener('click', function () { setTimeout(sync, 50); });
      });
      window.addEventListener('resize', onScroll, { passive: true });
      sync();
    });
  }

  /* ---------- 2. Card swatches: moved to ntd-card.js (10/8/26), loaded by card-product.liquid on every page ---------- */

  /* ---------- 3. Slider AJAX add-to-cart ---------- */

  document.addEventListener('submit', function (event) {
    var form = event.target && event.target.closest ? event.target.closest('.bs-atc-form') : null;
    if (!form) return;

    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return;

    event.preventDefault();

    var idInput = form.querySelector('.bs-variant-id, input[name="id"]');
    var btn = form.querySelector('.bs-atc-button, [type="submit"]');
    if (!idInput || !idInput.value) return;
    if (btn && btn.disabled) return;

    var label = btn ? btn.textContent : '';
    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Adding…';
    }

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(idInput.value), quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state.status) throw new Error(state.description || 'add failed');

        // Dawn removes the is-empty class in ProductForm, NOT in
        // CartDrawer.renderContents. Calling renderContents directly without
        // this left the drawer's empty-state CSS active, which hides the
        // header and items — an open drawer showing nothing but the footer.
        drawer.classList.remove('is-empty');
        var inner = drawer.querySelector('.drawer__inner');
        if (inner) inner.classList.remove('is-empty');
        var items = drawer.querySelector('cart-drawer-items');
        if (items) items.classList.remove('is-empty');

        // Dawn's CartDrawer.renderContents both re-renders and opens the drawer.
        drawer.renderContents(state);
        var bubble = state.sections && state.sections['cart-icon-bubble'];
        if (bubble) {
          var target = document.getElementById('cart-icon-bubble');
          if (target) {
            var doc = new DOMParser().parseFromString(bubble, 'text/html');
            var src = doc.querySelector('.shopify-section') || doc.body;
            target.innerHTML = src.innerHTML;
          }
        }
      })
      .catch(function () {
        form.submit();
      })
      .finally(function () {
        if (btn) {
          btn.disabled = false;
          btn.textContent = label;
        }
      });
  }, true);

  /* ---------- boot ---------- */

  function boot() {
    enhanceSliders();
    document.addEventListener('shopify:section:load', enhanceSliders);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
